import api from './api';
import { Lead, LeadFilters, LeadResponse, LeadStats } from '../types';

export const leadService = {
  async getLeads(filters: LeadFilters = {}): Promise<LeadResponse> {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value.toString());
      }
    });
    const response = await api.get(`/leads?${params.toString()}`);
    return response.data;
  },

  async getLead(id: string): Promise<Lead> {
    const response = await api.get(`/leads/${id}`);
    return response.data;
  },

  async getStats(): Promise<LeadStats> {
    const response = await api.get('/leads/stats/overview');
    return response.data;
  },

  async updateLead(id: string, updates: { status?: string; notes?: string }): Promise<Lead> {
    const response = await api.patch(`/leads/${id}`, updates);
    return response.data;
  },

  async deleteLead(id: string): Promise<void> {
    await api.delete(`/leads/${id}`);
  },
};
